import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  ShopifyMetafieldDefinitionsResponseDataSchema,
  ShopifyMetafieldOwnerType,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ShopifyMetafieldDefinitionsResponseDataSchema>>

export const shopifyMetafieldDefinitionsQuery = (ownerType: ShopifyMetafieldOwnerType) =>
  queryOptions({
    queryKey: ["shopifyMetafieldDefinitions", ownerType],
    queryFn: async () => {
      const response = await axios.get<Response>("/integrations/shopify/metafield-definitions", {
        params: { ownerType },
      })
      return response.data.data
    },
    staleTime: 5 * 60 * 1000,
  })
